import {
  PAYMENT_FAILED_AFTER_REDIRECT_KEY,
  PAYMENT_SUCCESS_AFTER_REDIRECT_KEY,
} from '@payment/const';

export function paymentDidSuccessRedirect(): boolean {
  return window.localStorage.getItem(PAYMENT_SUCCESS_AFTER_REDIRECT_KEY) === 'true';
}

export function paymentDidFailedRedirect(): boolean {
  return window.localStorage.getItem(PAYMENT_FAILED_AFTER_REDIRECT_KEY) === 'true';
}
